__webpack_require__.p = "http://kinixcreative.com/dev/meal-viewer/";